// src/modules/treasury/routes.jsx
// Treasury module routes. Pages are activated per phase.
// ComingSoon placeholder used until a phase is complete.

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BranchCashLedger from './pages/BranchCashLedger';
import BranchFundDashboard from './pages/BranchFundDashboard';
import BranchExpensesPage from './pages/BranchExpensesPage';
import PaymentApprovalDashboard from './pages/PaymentApprovalDashboard';
import CentralFundLedger from './pages/CentralFundLedger';
import BranchDayStatus from './pages/BranchDayStatus';
import EndOfDayClosure from './pages/EndOfDayClosure';
import ClosureApprovalDashboard from './pages/ClosureApprovalDashboard';
import HoDashboard from './pages/HoDashboard';
import BranchFundingHistory from './pages/BranchFundingHistory';
import InterBranchTransfer from './pages/InterBranchTransfer';
import AllTransfers from './pages/AllTransfers';
import TreasurySettings from './pages/TreasurySettings';

const TreasuryRoutes = () => (
  <Routes>
    <Route index element={<HoDashboard />} />
    <Route path="branch-fund" element={<BranchFundDashboard />} />
    <Route path="branch-expenses" element={<BranchExpensesPage />} />
    <Route path="cash-ledger" element={<BranchCashLedger />} />
    <Route path="payment-requests" element={<PaymentApprovalDashboard />} />
    <Route path="central-fund" element={<CentralFundLedger />} />
    <Route path="funding-history" element={<BranchFundingHistory />} />
    <Route path="transfers" element={<InterBranchTransfer />} />
    <Route path="all-transfers" element={<AllTransfers />} />
    <Route path="day-status" element={<BranchDayStatus />} />
    <Route path="eod-closure" element={<EndOfDayClosure />} />
    <Route path="closure-approvals" element={<ClosureApprovalDashboard />} />
    <Route path="ho-dashboard" element={<HoDashboard />} />
    <Route path="settings" element={<TreasurySettings />} />
    <Route path="*" element={<Navigate to="/treasury" replace />} />
  </Routes>
);

export default TreasuryRoutes;
